module.exports = __webpack_public_path__ + "static/img/black-powder_256.6e32e6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/black-powder_256.png
// module id = qZAz
// module chunks = 0